const trackedFilterActions = [
  "brain/modules/handleFilterChange",
  "brain/modules/resetAllFilters",
  "brain/modules/resetFilters",
  "brain/drivers/handleFilterChange",
  "brain/drivers/resetAllFilters",
  "brain/drivers/resetFilters",
  "brain/global/setFilter",
];

const trackedFilterMutations = [
  "brain/modules/resetSpecificFilterGroup",
  "brain/drivers/resetSpecificFilterGroup",
  "brain/global/resetGlobalFilters",
];

const trackedDisplayActions = ["brain/ui/showModules", "brain/ui/showDrivers"];

const trackedDisplayMutations = [
  "brain/ui/minimizeInput",
  "brain/ui/setPaneSize",
  "brain/ui/setModuleColumnVisibility",
  "brain/ui/setDriverColumnVisibility",
  "brain/ui/resetColumnVisibility",
];
const trackedSolutionMutations = [
  "brain/solutions/setSolutions",
  "brain/solutions/removeSensor",
  "brain/solutions/removeBridge",
  "brain/solutions/removeEmergencyDriver",
  "brain/solutions/setMultiLengthModules",
  "brain/solutions/removeSolution",
  "brain/solutions/setBridge",
];

const trackedSolutionActions = [
  "brain/solutions/add",
  "brain/solutions/setDriverFromUrl",
  "brain/solutions/handleNewSolution",
  "brain/solutions/clearSolutions",
  "brain/solutions/handleActiveSolution",
  "brain/solutions/removeModule",
  "brain/solutions/removeDriver",
  "brain/solutions/setSensorFromUrl",
];

export default function autosave(store) {
  store.subscribe((mutation) => {
    // Autosave filter mutations
    if (
      trackedFilterMutations.includes(mutation.type) &&
      store.getters["brain/auth/isLoggedIn"] &&
      !store.getters["brain/auth/isImpersonating"] &&
      !store.getters["brain/auth/isAdministering"]
    ) {
      store.dispatch("brain/global/autoSaveAllFilters");
    }

    // Autosave display mutations
    if (
      trackedDisplayMutations.includes(mutation.type) &&
      store.getters["brain/auth/isLoggedIn"] &&
      !store.getters["brain/auth/isImpersonating"] &&
      !store.getters["brain/auth/isAdministering"] &&
      mutation.payload.save
    ) {
      store.dispatch("brain/global/autoSaveAllDisplaySettings");
    }

    // Autosave solution mutations
    if (
      trackedSolutionMutations.includes(mutation.type) &&
      store.getters["brain/auth/isLoggedIn"] &&
      !store.getters["brain/auth/isImpersonating"] &&
      !store.getters["brain/auth/isAdministering"]
    ) {
      localStorage.setItem(
        "solutions",
        JSON.stringify({
          solutions: store.getters["brain/solutions/solutions"],
          active: store.getters["brain/solutions/active"],
          solutionNumber: store.getters["brain/solutions/solutionNumber"],
        })
      );
    }
  });

  store.subscribeAction({
    after: (action) => {
      // Autosave filter actions
      if (
        trackedFilterActions.includes(action.type) &&
        store.getters["brain/auth/isLoggedIn"] &&
        !store.getters["brain/auth/isImpersonating"] &&
        !store.getters["brain/auth/isAdministering"]
      ) {
        store.dispatch("brain/global/autoSaveAllFilters");
      }

      // Autosave display actions
      if (
        trackedDisplayActions.includes(action.type) &&
        store.getters["brain/auth/isLoggedIn"] &&
        !store.getters["brain/auth/isImpersonating"] &&
        !store.getters["brain/auth/isAdministering"] &&
        action.payload.save
      ) {
        store.dispatch("brain/global/autoSaveAllDisplaySettings");
      }

      // Autosave solution actions
      if (
        trackedSolutionActions.includes(action.type) &&
        store.getters["brain/auth/isLoggedIn"] &&
        !store.getters["brain/auth/isImpersonating"] &&
        !store.getters["brain/auth/isAdministering"]
      ) {
        localStorage.setItem(
          "solutions",
          JSON.stringify({
            solutions: store.getters["brain/solutions/solutions"],
            active: store.getters["brain/solutions/active"],
            solutionNumber: store.getters["brain/solutions/solutionNumber"],
          })
        );
      }
    },
  });
}
